export default {
    app: 'sekiro',
    api_prefix: "/sekiro-api",
    login_token_key: 'Sekiro-Token',
    login_user_key: "Sekiro-USER",
    doc_path: '/sekiro-doc/index.html',
    main_site: 'https://www.baidu.com',
    footer: 'sekiro-系统框架',
    copyRight: '2023 因体信息公司'
}